import 'jquery-validation';
import datatables from 'datatables';
import 'datatables.mark.js';

export default () => {

    if($('#resend').length > 0) {
        $('#resend').on('click', function(){
            if($('#resend-form').css('display') === 'flex') {
                $('#resend-form').css('display', 'none');
            } else {
                $('#resend-form').css('display', 'flex');
            }
        });
    }

    $('.portal').on('click', function(){
        $(this).toggleClass('active');
    });
    if($('#register-form').length > 0) {
        let part = 1;

        $('.next').each(function(){
            $(this).on('click', function(){
                event.preventDefault();
                $('#register-form').submit();
            });
        });
        $('.back').each(function(){
            $(this).on('click', function(){
                event.preventDefault();
                part--;
                $('#tab1').addClass('active');
                $('#tab2').removeClass('active');
            });
        });

        $("#register-form").validate({
            rules: {
                serial: {
                    required: true,
                    minlength: 11,
                },
                firstname: {
                    required: true,
                },
                lastname: {
                    required: true,
                },
                email: {
                    required: true,
                    email: true,
                    remote: {
                        url: "/check-email.php",
                        type: "post",
                        dataType: 'json',
                        complete: function(data) {
                            if(data.responseText == 'true'){
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                },
                conf_email: {
                    equalTo : "#email"
                },
                country: {
                    required: true,
                },
                employer: {
                    required: true,
                },
                user: {
                    required: true,
                    remote: {
                        url: "/check-user.php",
                        type: "post",
                        dataType: 'json',
                        complete: function(data) {
                            if(data.responseText == 'true'){
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                },
                u_password: {
                    required: true,
                    minlength : 8,
                },
                conf_password: {
                    minlength : 8,
                    equalTo : "#password"
                },
                privacy: {
                    required: true,
                },
                extra: {
                    required: true,
                },

            },
            messages: {
                serial: 'Not a valid serial number',
                firstname: '',
                lastname: '',
                email: {
                    remote: 'Email already in use',
                },
                conf_email: 'Emails must match',
                country: '',
                employer: '',
                user: {
                    remote: 'Username already in use',
                },
                u_password: 'Password to be minimum 8 characters long',
                conf_password: 'Passwords must match',
                privacy: '',
                extra: '',
            },
            submitHandler: function(form) {
                if(part == 1) {
                    $('#tab1').removeClass('active');
                    $('#tab2').addClass('active');
                    part++;
                } else {
                    form.submit();
                }
            }
        });
    }

    if($('.page-settings').length > 0) {
        $('.edit').each(function() {
            $(this).on('click', function(){
                $('.form.active').find('input').prop('disabled', true);
                $('.form.active').attr('aria-hidden', 'true');
                $('.form.active').removeClass('active');
                $(this).siblings('.form').addClass('active');
                $(this).siblings('.form').attr('aria-hidden', 'false');
                $(this).siblings('.form').find('input:not([name="serialfirst"])').prop('disabled', false);

                if($(this).hasClass('password')) {
                    $(this).siblings('.form').find('input:not([name="serialfirst"])').val('');
                }
            });
        });
        $('.cancel').each(function() {
            $(this).on('click', function(){
                event.preventDefault();
                $(this).parent().removeClass('active');
                $(this).parent().attr('aria-hidden', 'true');
                $(this).siblings('input').prop('disabled', true);
            });
        });

        $(".form").each(function(){
            $(this).validate({
                rules: {
                    serial: {
                        required: true,
                        minlength: 11,
                        remote: {
                            url: "/check-serial.php",
                            type: "post",
                            dataType: 'json',
                            complete: function(data) {
                                if(data.responseText == 'true'){
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        },
                    },
                    firstname: {
                        required: true,
                    },
                    lastname: {
                        required: true,
                    },
                    email: {
                        required: true,
                        email: true,
                    },
                    country: {
                        required: true,
                    },
                    employer: {
                        required: true,
                    },
                    user: {
                        required: true,
                    },
                    u_password: {
                        minlength : 8,
                    },
                    conf_password: {
                        minlength : 8,
                        equalTo : "#password"
                    },
                    privacy: {
                        required: true,
                    },
                    extra: {
                        required: true,
                    },

                },
                messages: {
                    serial: {
                        remote: 'Not a valid serial number',
                    },
                    firstname: '',
                    lastname: '',
                    email: '',
                    country: '',
                    employer: '',
                    user: '',
                    u_password: 'Password to be minimum 8 characters long',
                    conf_password: 'Passwords must match',
                    privacy: '',
                    extra: '',
                },
                submitHandler: function(form) {
                    form.submit();
                }
            });
        })
    }

    if($('.table-section').length > 0) {
        $('.table').each(function(){
            var table = $(this).DataTable({
              paging: false,
              search: false,
              "autoWidth": false,
              "order": [0, 'desc'],
              mark: true,
            });
            $('.searchField[data-for='+ $(this).parent().parent().attr('id') +']').keyup(function(){
                table.search($(this).val()).draw() ;
            })
        });
    }
    if($('.options-section').length > 0) {
        $('#document-type').on('change', function(){
            let val = $(this).find(":selected").val();
            $('.table-wrapper.active').removeClass('active');
            $('.searchField.active').removeClass('active');
            $('#' + val).addClass('active');
            $('.searchField[data-for='+ val +']').addClass('active');
        });
    }
};
